import { Link } from "react-router-dom";
import { Linkedin, Instagram } from "lucide-react";
import { LINKEDIN_URL, ASSETS } from "@/lib/api";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="section-forest border-t border-white/10"
        >
            <div className="container-x mx-auto max-w-7xl py-16 grid gap-12 md:grid-cols-4">
                <div className="md:col-span-2">
                    <div className="flex items-center gap-3">
                        <img
                            src={ASSETS.logo}
                            alt="Purposeful, Inc. logo"
                            loading="lazy"
                            decoding="async"
                            className="h-10 w-10 rounded-md ring-1 ring-white/10 object-cover"
                        />
                        <div className="font-display text-xl font-bold">
                            Purposeful<span className="text-[#D4AF37]">,</span> Inc.
                        </div>
                    </div>
                    <div className="text-muted mt-4 max-w-md text-sm leading-relaxed space-y-2">
                        <p className="text-white/90">Building businesses that matter.</p>
                        <p>The book. The founders. The network. The ecosystem.</p>
                    </div>
                    <div className="mt-6 flex gap-3">
                        <a
                            href={LINKEDIN_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-linkedin-link"
                            className="rounded-full border border-white/15 p-2.5 hover:border-[#D4AF37] hover:text-[#D4AF37] transition"
                            aria-label="LinkedIn"
                        >
                            <Linkedin size={16} />
                        </a>
                        <a
                            href="https://www.instagram.com/purposeful.inc/"
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-instagram-link"
                            className="rounded-full border border-white/15 p-2.5 hover:border-[#D4AF37] hover:text-[#D4AF37] transition"
                            aria-label="Instagram"
                        >
                            <Instagram size={16} />
                        </a>
                    </div>
                </div>

                <div>
                    <div className="overline mb-4">Explore</div>
                    <ul className="space-y-2 text-sm text-zinc-300">
                        <li><Link to="/book" className="hover:text-white">The Book</Link></li>
                        <li><Link to="/network" className="hover:text-white">The Network</Link></li>
                        <li><Link to="/ecosystem" className="hover:text-white">The Ecosystem</Link></li>
                        <li><Link to="/directory" className="hover:text-white">Directory</Link></li>
                        <li><Link to="/founder-stories" className="hover:text-white">Founder Stories</Link></li>
                        <li><Link to="/about" className="hover:text-white">About</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="overline mb-4">Connect</div>
                    <ul className="space-y-2 text-sm text-zinc-300">
                        <li><Link to="/join" className="hover:text-white">Join Purposeful</Link></li>
                        <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
                        <li><a href={LINKEDIN_URL} target="_blank" rel="noreferrer" className="hover:text-white">LinkedIn</a></li>
                        <li><a href="https://www.instagram.com/purposeful.inc/" target="_blank" rel="noreferrer" className="hover:text-white">Instagram</a></li>
                        <li><Link to="/admin/login" className="hover:text-white text-xs text-zinc-500">Admin</Link></li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="container-x mx-auto max-w-7xl py-6 flex flex-col gap-2 md:flex-row md:justify-between text-xs text-zinc-500">
                    <span>© {new Date().getFullYear()} Purposeful, Inc. All rights reserved.</span>
                    <span className="font-mono uppercase tracking-widest">Building businesses that matter</span>
                </div>
            </div>
        </footer>
    );
}
